module.exports = __webpack_public_path__ + "img/i-fast-forward-mono.deffc6b0.svg";